import type { ReactElement } from 'react'

export default function Cart(): ReactElement {
  const someObject: any = {}

  return <div>{someObject.someProperty.throw}</div>
}
